import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { BiData } from '@wix/da-bi/pkg/events';
import SiteHeaderIconButton from '../_partials/SiteHeaderIconButton';
var SearchButton = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(SiteHeaderIconButton, { icon: SearchIcon, biData: BiData({
            evid: 700,
            link_name: 'search',
        }), ariaLabel: t('siteHeader.search'), className: classnames('ignore-react-onclickoutside', className), iconClassName: iconClassName, onClick: onClick }));
};
export default SearchButton;
//# sourceMappingURL=SearchButton.js.map